// Nepal Province to Code mapping
export const PROVINCE_MAP = {
  'Koshi': '1',
  'Madhesh': '2',
  'Bagmati': '3',
  'Gandaki': '4',
  'Lumbini': '5',
  'Karnali': '6',
  'Sudurpashchim': '7',
};

// Reverse mapping
export const PROVINCE_CODE_MAP = {
  '1': 'Koshi',
  '2': 'Madhesh',
  '3': 'Bagmati',
  '4': 'Gandaki',
  '5': 'Lumbini',
  '6': 'Karnali',
  '7': 'Sudurpashchim',
};

// District to Province mapping
export const DISTRICT_PROVINCE_MAP = {
  // Koshi (1)
  'Bhojpur': 'Koshi', 'Dhankuta': 'Koshi', 'Ilam': 'Koshi', 'Jhapa': 'Koshi',
  'Khotang': 'Koshi', 'Morang': 'Koshi', 'Okhaldhunga': 'Koshi', 'Panchthar': 'Koshi',
  'Sankhuwasabha': 'Koshi', 'Sunsari': 'Koshi', 'Terhathum': 'Koshi',
  
  // Madhesh (2)
  'Araria': 'Madhesh', 'Dhanusa': 'Madhesh', 'Mahottari': 'Madhesh', 'Parsa': 'Madhesh',
  'Rautahat': 'Madhesh', 'Saptari': 'Madhesh', 'Siraha': 'Madhesh',
  
  // Bagmati (3)
  'Bhaktapur': 'Bagmati', 'Chitwan': 'Bagmati', 'Dhading': 'Bagmati', 'Dolakha': 'Bagmati',
  'Kathmandu': 'Bagmati', 'Kavre Palanchok': 'Bagmati', 'Lalitpur': 'Bagmati', 'Nuwakot': 'Bagmati',
  'Ramechhap': 'Bagmati', 'Rasuwa': 'Bagmati', 'Sindhuli': 'Bagmati', 'Sindhupalchok': 'Bagmati',
  
  // Gandaki (4)
  'Gorkha': 'Gandaki', 'Kaski': 'Gandaki', 'Lamjung': 'Gandaki', 'Manang': 'Gandaki',
  'Mustang': 'Gandaki', 'Myagdi': 'Gandaki', 'Parbat': 'Gandaki', 'Syangja': 'Gandaki', 'Tanahun': 'Gandaki',
  
  // Lumbini (5)
  'Argakhanchi': 'Lumbini', 'Baglung': 'Lumbini', 'Dang': 'Lumbini', 'Gulmi': 'Lumbini',
  'Kapilvastu': 'Lumbini', 'Nawalparasi': 'Lumbini', 'Palpa': 'Lumbini', 'Rupandehi': 'Lumbini',
  
  // Karnali (6)
  'Achham': 'Karnali', 'Baitadi': 'Karnali', 'Bajhang': 'Karnali', 'Bajura': 'Karnali',
  'Banke': 'Karnali', 'Dailekh': 'Karnali', 'Doti': 'Karnali', 'Jajarkot': 'Karnali',
  'Jumla': 'Karnali', 'Kalikot': 'Karnali', 'Karnali': 'Karnali',
  
  // Sudurpashchim (7)
  'Dadeldhura': 'Sudurpashchim', 'Kanchanpur': 'Sudurpashchim',
};

// Extract province and district from Nominatim address
export const extractNepalLocationFromAddress = (address) => {
  let province = '';
  let district = '';
  let municipality = '';
  
  if (!address) return { province, district, municipality };
  
  // Try to find district from address
  for (const [dist, prov] of Object.entries(DISTRICT_PROVINCE_MAP)) {
    if (address.county && address.county.toLowerCase().includes(dist.toLowerCase())) {
      district = dist;
      province = prov;
      break;
    }
    if (address.state && address.state.toLowerCase().includes(dist.toLowerCase())) {
      district = dist;
      province = prov;
      break;
    }
  }
  
  // Try to get municipality from city/town/village
  if (address.city) municipality = address.city;
  else if (address.town) municipality = address.town;
  else if (address.village) municipality = address.village;
  else if (address.county) municipality = address.county;
  
  // If we couldn't find district, try to find province
  if (!province) {
    for (const [prov, code] of Object.entries(PROVINCE_MAP)) {
      if (address.state && address.state.toLowerCase().includes(prov.toLowerCase())) {
        province = prov;
        break;
      }
    }
  }
  
  return { province, district, municipality };
};

// Function to find location by coordinates (with tolerance)
export const findLocationByCoordinates = (lat, lon) => {
  // This is now handled by Nominatim + extractNepalLocationFromAddress
  return null;
};

// Function to find location by name
export const findLocationByName = (name) => {
  // This is now handled by Nominatim search
  return null;
};
